/**
 * Created by Mike Naughton on 12/22/17.
 */

import WindowView from "core/views/WindowView";
import velocity from "velocity-animate";
import Page from "core/Page";

export default {
  hide: function () {
    var self = this;
    var doHide = function () {
      WindowView.prototype.hide.call(self);
    };

    this.trigger("hiding");

    if (this.isVisible()) {
      velocity(
        this.el,
        {
          left: 1 + Page.getWidth(),
        },
        {
          complete: function () {
            doHide();
          },
          duration: 200,
          queue: false,
        }
      );
    } else {
      doHide();
    }
  },

  show: function () {
    var self = this;
    var doShow = function () {
      WindowView.prototype.show.call(self);
    };

    if (!this.isVisible()) {
      this.$el.css("left", Page.getWidth());
      this.$el.show();
      this.trigger("showing");
      velocity(
        this.el,
        {
          left: Page.getWidth() - this.size().width,
        },
        {
          complete: function () {
            doShow();
          },
          duration: 200,
          queue: false,
        }
      );
    } else {
      this.trigger("showing");
      doShow();
    }
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/map/helpers/HideRight.mixin.js
// module id = 955
// module chunks = 1